const Divider = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      margin: 0,
    }),
  },
};

export default Divider;
